import React from 'react';
import {injectIntl} from 'react-intl';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildBarColumnChartOptions = (type, config, data, hints, intl) => {
    const sum = data.series.map((s) => s.values.reduce((a, b) => a + b, 0));

    return fillChartOptions({
        chart: {
            type,
        },
        legend: {enabled: false},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            title: {enabled: false},
        },
        series: data.series.map((s, i) => ({
            data: s.values.map((value) => percentualize(value, sum[i], hints)),
            name: s.name,
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '{point.y:.2f}' : '{point.y:.1f}%',
            },
        })),
        tooltip: {
            formatter: function() {
                return hints.absolute ? `${this.x}: ${this.y}` : `${this.x}: ${this.y}%`;
            },
        },
    }, config, data, hints, intl);
};

const buildPieChartOptions = (config, data, hints, intl) => {
    const sum = data.series.map((s) => s.values.reduce((a, b) => a + b, 0));

    return fillChartOptions({
        chart: {
            type: 'pie',
        },
        legend: {enabled: false},
        series: data.series.map((s, i) => ({
            name: s.name,
            data: data.categories.map((category, j) => ({
                name: category,
                y: percentualize(data.series[i].values[j], sum[i], hints),
            })),
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '<b>{point.name}</b>: {point.y:.2f}' : '<b>{point.name}</b>: {point.y:.1f}%',
            },
        })),
        tooltip: {
            formatter: function() {
                return hints.absolute ? `${this.y}` : `${this.y}%`;
            },
        },
    }, config, data, hints, intl);
};

const builders = {
    bar: buildBarColumnChartOptions.bind(undefined, 'bar'),
    column: buildBarColumnChartOptions.bind(undefined, 'column'),
    pie: buildPieChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.column(config, data, hints, intl);
};

const SingleChoiceWithMax = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} maxLabel={`t=${params.max}`} />
);

export default injectIntl(SingleChoiceWithMax);
